<template>
   <div class="stop" :style="{ bottom }" :class="hide ? 'show' : 'hide'">
      <div class="btn" @click="stop" :style="plain ? 'opacity:' + opacity : 'opacity: 1'">
         <svg-icon iconClass="stop" class="aiStop t-m-r-5" />
         <span class="t-m-l-5">停止生成</span>
      </div>
   </div>
</template>
<script>
import api from '@/api/api'
export default {
   props: {
      bottom: {
         type: String,
         default: '80px'
      },
      hide: {
         type: Boolean,
         default: false
      },
      emit: {
         type: Boolean,
         default: false
      },
      plain: {
         type: Boolean,
         default: false
      },
      opacity: {
         type: String,
         default: '0.5'
      }
   },
   data() {
      return {}
   },
   beforeDestroy() {
      localStorage.removeItem('AICreateId')
   },
   methods: {
      stop() {
         const AICreateId = localStorage.getItem('AICreateId')
         console.log('AICreateId=', AICreateId)
         api.aiStop({ logId: AICreateId }).then(res => {
            if (res.code === 200) {
               localStorage.removeItem('AICreateId')

               if (this.emit) {
                  this.$notify({
                     type: 'success',
                     title: '提示',
                     message: '已取消AI生成',
                  });
                  // this.$message.success('已取消AI生成');
                  this.$emit('stop', true)
               } else {
                  this.$parent.clearTimer(true)
                  this.$notify({
                     type: 'success',
                     title: '提示',
                     message: '已取消AI生成',
                  });
                  // this.$message.success('已取消AI生成');
               }
               //刷新用户信息-基础会员字符刷新
               this.getUserInfo()
            } else {
               this.$message.warning(res.msg)
            }
         })

      }
   }
}
</script>
<style lang="scss" scoped>
.hide {
   opacity: 0;
   z-index: -1;
}

.show {
   opacity: 1;
   z-index: 99;
}

.stop {
   position: absolute;
   left: 0;
   width: 100%;
   display: flex;
   justify-content: center;

   transition: all 0.3 ease-in-out;

   .btn {
      height: 32px;
      display: flex;
      border-radius: 32px;
      align-items: center;
      justify-content: center;
      width: 124px;
      background: rgba(0, 0, 0, .4);
      cursor: pointer;

      &:hover {
         opacity: 1 !important;
      }

      span {
         color: #fff;
         font-size: 16px;
         line-height: 1;
         font-family: Microsoft YaHei, Microsoft YaHei;
      }
   }
}

.aiStop {
   color: #fff;
}
</style>